module.exports = __webpack_public_path__ + "assets/img/share.4c537d67.png";